/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_LatestInputs */

const en_directory_home_latest = /** @type {(inputs: Directory_Home_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest AI Tools`)
};

const zh_directory_home_latest = /** @type {(inputs: Directory_Home_LatestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新 AI 工具`)
};

/**
* | output |
* | --- |
* | "Latest AI Tools" |
*
* @param {Directory_Home_LatestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_latest = /** @type {((inputs?: Directory_Home_LatestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_LatestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_latest(inputs)
	return zh_directory_home_latest(inputs)
});
export { directory_home_latest as "directory.home.latest" }